import React from "react";
import Navbar from "./Navbar";
import Header from "../pages/Header";
import Summary from "../pages/Summary";
import QuickLinks from "../pages/QuickLinks";
import FooterNew from "./FooterNew";
const Home = () => {
  return (
    <div style={{ maxWidth: "100%", overflowX: "hidden" }}>
      <Navbar />
      <Header />
      <Summary />
      <QuickLinks />
      <FooterNew />
    </div>
  );
};

export default Home;
